var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 9 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.073.448a.494.494 0 0 1 .057.756L1.41 8l6.72 6.796a.494.494 0 0 1-.057.756.66.66 0 0 1-.855-.05L.15 8.353a.49.49 0 0 1 0-.706L7.218.498a.66.66 0 0 1 .855-.05",
  clipRule: "evenodd"
})));
export { SvgChevronBack as ReactComponent };